import { durationConverter } from 'utils/duration';

import {
  ConditionFieldDurationObject,
  ConditionFieldDurationUnit,
} from '../../components/filters/components/condition/components/field/components/duration/conditionFieldDuration.types';

export function convertDurationToMs(
  duration: number,
  unit: ConditionFieldDurationUnit,
): number {
  switch (unit) {
    case 'seconds':
      return durationConverter.seconds.toMilliseconds(duration);
    case 'minutes':
      return durationConverter.minutes.toMilliseconds(duration);
    case 'hours':
      return durationConverter.hours.toMilliseconds(duration);
    default:
      return 0;
  }
}

export function convertMsToDuration(
  milliseconds: number,
): ConditionFieldDurationObject {
  const { hours, minutes, seconds } =
    durationConverter.milliseconds.toHoursMinutesSeconds(milliseconds);

  if (hours) {
    return { value: hours, unit: 'hours' };
  }
  if (minutes) {
    if (seconds) {
      const minutesToSeconds = minutes * 60 + seconds;
      return { value: minutesToSeconds, unit: 'seconds' };
    }
    return { value: minutes, unit: 'minutes' };
  }
  return { value: seconds, unit: 'seconds' };
}
